import AppConstants from "../config/app.constants";

let VaultOperationsService = function ($http, $q) {

    let getRouteList = (searchText, startDate, endDate, offset, limit, sortASC, sortColumn, timezone, vaultDateRoutes, branch, routeId) => {
        return $http
            .get(AppConstants.api + `/vault-operations/get-route-list`, {
                params: {
                    searchText,
                    startDate,
                    endDate,
                    offset,
                    limit,
                    sortASC,
                    sortColumn,
                    timezone,
                    vaultDateRoutes,
                    branch,
                    routeId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getDeliveryShipmentList = (searchText, startDate, endDate, offset, limit, sortASC, sortColumn, timezone, branch) => {
        return $http
            .get(AppConstants.api + `/vault-operations/get-delivery-shipment-list`, {
                params: {
                    searchText,
                    startDate,
                    endDate,
                    offset,
                    limit,
                    sortASC,
                    sortColumn,
                    timezone,
                    branch
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getPickupShipmentList = (searchText, startDate, endDate, offset, limit, sortASC, sortColumn, timezone, branch) => {
        return $http
            .get(AppConstants.api + `/vault-operations/get-pickup-shipment-list`, {
                params: {
                    searchText,
                    startDate,
                    endDate,
                    offset,
                    limit,
                    sortASC,
                    sortColumn,
                    timezone,
                    branch
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let shipmentMarkUndelivered = (trackingId, routeId, supervisorId, branchId, loadedAmount, shipmentAmount, reason, fromLocationId, toLocationId, qty, shiptypeId) => {
        return $http
            .post(AppConstants.api + `/vault-operations/shipment-mark-undelivered`, {
                trackingId,
                routeId,
                supervisorId,
                branchId,
                loadedAmount,
                shipmentAmount,
                reason,
                fromLocationId,
                toLocationId,
                qty,
                shiptypeId

            })
            .then((res) => {
                return res.data
            })
    };

    let updateDeliveryShipment = (shipmentObj) => {
        return $http
            .post(AppConstants.api + `/vault-operations/update-delivery-shipment`, {
                shipmentObj
            })
            .then((res) => {
                return res.data
            })
    };

    let markHoldAsDelivered = (shipmentObj) => {
        return $http
            .post(AppConstants.api + `/vault-operations/shipment-hold-mark-delivered`, {
                shipmentObj
            })
            .then((res) => {
                return res.data
            })
    };

    let updatePickupShipment = (shipmentObj) => {
        return $http
            .post(AppConstants.api + `/vault-operations/update-pickup-shipment`, {
                shipmentObj
            })
            .then((res) => {
                return res.data
            })
    };

    let shipmentCheckIn = (branchId, trackingId, routeId, userId, vaultDate) => {
        return $http
            .post(AppConstants.api + `/vault-operations/shipment-check-in`, {
                branchId,
                trackingId,
                routeId,
                userId,
                vaultDate
            })
            .then((res) => {
                return res.data
            })
    };

    let shipmentCheckInDelivery = (branchId, trackingId, routeId, userId, vaultDate, convertToPickup) => {
        return $http
            .post(AppConstants.api + `/vault-operations/convert-immediate-delivery-to-pickup`, {
                branchId,
                trackingId,
                routeId,
                userId,
                vaultDate,
                convertToPickup
            })
            .then((res) => {
                return res.data
            })
    };

    let shipmentCheckOut = (branchId, trackingId, routeId, userId, vaultDate) => {
        return $http
            .post(AppConstants.api + `/vault-operations/shipment-check-out`, {
                branchId,
                trackingId,
                routeId,
                userId,
                vaultDate
            })
            .then((res) => {
                return res.data
            })
    };

    let removeHoldShipment = (trackingId, userId, branchId) => {
        return $http
            .post(AppConstants.api + `/vault-operations/remove-hold-shipment`, {
                trackingId,
                userId,
                branchId
            })
    }

    let updateRouteDetails = (branchId, routeId, vaultDate, vehicleId, messengerId, driverId, guardId,
                              leaveTime, arriveTime, complTime, begMiles, endMiles, browserTimezone, supervisorId) => {
        return $http
            .post(AppConstants.api + `/vault-operations/update-route-details`, {
                branchId,
                routeId,
                vaultDate,
                vehicleId,
                messengerId,
                driverId,
                guardId,
                leaveTime,
                arriveTime,
                complTime,
                begMiles,
                endMiles,
                browserTimezone,
                supervisorId
            })
            .then((res) => {
                return res.data
            })
    }

    let undoCheckInTime = (routeId, routeDate, branchId) => {
        return $http
            .post(AppConstants.api + `/vault-operations/undo-check-in-time`, {
                routeId, routeDate, branchId
            })
            .then((res) => {
                return res.data
            })
    };

    let getFilterRouteList = (startDate, endDate, branch, vaultDateRoutes, searchText, limit, offset) => {
        return $http
            .get(AppConstants.api + `/vault-operations/get-filter-route-list`, {
                params: {
                    startDate,
                    endDate,
                    branch,
                    vaultDateRoutes,
                    searchText,
                    limit,
                    offset
                }
            })
            .then((res) => {
                return res.data
            });
    }

    let convertToBagoutablePickup = (trackingId) => {
        return $http
            .post(AppConstants.api + `/vault-operations/convert-to-bagoutable-pickup`, {
                trackingId
            })
            .then((res) => {
                return res.data
            })
    }

    let convertToPickup = (trackingId, branchId, routeId, userId, vaultDate) => {
        return $http
            .post(AppConstants.api + `/vault-operations/convert-to-pickup`, {
                trackingId,
                branchId,
                routeId,
                userId,
                vaultDate
            })
            .then((res) => {
                return res.data
            })
    }

    let rescheduleRouteDeliveries = (fromRouteId, fromVaultDate, toRouteId, toVaultDate, branchId, comments, shipments, supervisorId) => {
        return $http
            .post(AppConstants.api + `/vault-operations/reschedule-route-deliveries`, {
                fromRouteId,
                fromVaultDate,
                toRouteId,
                toVaultDate,
                branchId,
                comments,
                shipments,
                supervisorId
            })
            .then((res) => {
                return res.data
            })
    }

    let getNotDeliveredShipments = (routeId, vaultDate, branchId) => {
        return $http
            .get(AppConstants.api + `/vault-operations/get-not-delivered-shipments`, {
                params: {
                    routeId,
                    vaultDate,
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let markAllDelivered = (branchId, routeId, vaultDate, supervisorId) => {
        return $http
            .post(AppConstants.api + `/vault-operations/mark-all-delivered`, {
                branchId,
                routeId,
                vaultDate,
                supervisorId
            })
            .then((res) => {
                return res.data
            })
    }


    return {
        getRouteList,
        getDeliveryShipmentList,
        getPickupShipmentList,
        shipmentMarkUndelivered,
        updateDeliveryShipment,
        updatePickupShipment,
        shipmentCheckIn,
        shipmentCheckInDelivery,
        shipmentCheckOut,
        removeHoldShipment,
        updateRouteDetails,
        undoCheckInTime,
        getFilterRouteList,
        markHoldAsDelivered,
        convertToBagoutablePickup,
        convertToPickup,
        rescheduleRouteDeliveries,
        getNotDeliveredShipments,
        markAllDelivered
    }
}

VaultOperationsService.$inject = ['$http', '$q'];

export default VaultOperationsService;



// WEBPACK FOOTER //
// ./client/app/services/vault-operations.service.js